import script from "./MapElemInfoComment.vue?vue&type=script&setup=true&lang=ts"
export * from "./MapElemInfoComment.vue?vue&type=script&setup=true&lang=ts"

import "./MapElemInfoComment.vue?vue&type=style&index=0&id=51c4b458&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51c4b458"]])

export default __exports__